export default __webpack_public_path__ + "static/media/img6.e8972fd8.jpg";